(() => {
  const ROOT_SELECTOR = '.drawer__recommendations';
  const LIST_NAME = 'Lady May Table Pairings';
  const EVENT_PREFIX = 'lady_may_pairing_';
  let pendingAdd = null;
  let lastImpression = { signature: '', at: 0 };

  const productHandle = (node) => {
    const link = node?.closest('li')?.querySelector('a[href*="/products/"]') || node?.closest('a[href*="/products/"]');
    if (!link) return '';
    try { return new URL(link.href, location.origin).pathname.split('/').filter(Boolean).pop() || ''; }
    catch (_) { return ''; }
  };

  const recommendationItems = (root = document.querySelector(ROOT_SELECTOR)) => {
    if (!root) return [];
    return [...root.querySelectorAll('li[id^="Slide-CartDrawerRecommendations"]')].map((item, index) => {
      const link = item.querySelector('a[href*="/products/"]');
      return { item_id: productHandle(link), item_name: link?.textContent?.trim() || '', index: index + 1, item_list_name: LIST_NAME };
    }).filter((item) => item.item_id);
  };

  const cartHandles = () => [...new Set([...document.querySelectorAll('#cart-drawer-contents a[href*="/products/"]')]
    .filter((link) => !link.closest(ROOT_SELECTOR))
    .map((link) => productHandle(link))
    .filter(Boolean))];

  const publish = (eventName, data = {}) => {
    const payload = {
      item_list_name: LIST_NAME,
      source_collection: 'lady-may-table-pairings',
      page_location: location.href,
      ...data,
    };
    try { window.Shopify?.analytics?.publish(`lady_may:${eventName}`, payload); } catch (_) {}
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', eventName, { event_category: 'cart_upsell', ...payload });
      } else {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: eventName, ...payload });
      }
    } catch (_) {}
    try {
      if (typeof window.fbq === 'function') {
        const metaName = eventName.split('_').map((part) => part.charAt(0).toUpperCase() + part.slice(1)).join('');
        window.fbq('trackCustom', metaName, payload);
      }
    } catch (_) {}
  };

  const trackImpression = () => {
    const drawer = document.querySelector('#cart-drawer');
    const root = document.querySelector(ROOT_SELECTOR);
    if (!drawer || drawer.hidden || !root) return;
    const items = recommendationItems(root);
    if (!items.length) return;
    const cart = cartHandles();
    const signature = `${cart.join(',')}|${items.map((item) => item.item_id).join(',')}`;
    const now = Date.now();
    if (lastImpression.signature === signature && now - lastImpression.at < 2000) return;
    lastImpression = { signature, at: now };
    publish(`${EVENT_PREFIX}impression`, { cart_product_handles: cart, items });
  };

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-drawer-to-open="cart-drawer"]')) setTimeout(trackImpression, 450);
    const link = event.target.closest(`${ROOT_SELECTOR} a[href*="/products/"]`);
    if (!link) return;
    const item = link.closest('li');
    publish(`${EVENT_PREFIX}click`, {
      cart_product_handles: cartHandles(),
      item_id: productHandle(link),
      item_name: link.textContent?.trim() || '',
      index: item ? [...item.parentElement.children].indexOf(item) + 1 : null,
    });
  });

  document.addEventListener('submit', (event) => {
    const form = event.target.closest(`${ROOT_SELECTOR} form[action*="/cart/add"]`);
    if (!form) return;
    pendingAdd = {
      variant_id: String(new FormData(form).get('id') || ''),
      item_id: productHandle(form),
      cart_product_handles: cartHandles(),
      started_at: Date.now(),
    };
  });

  const initialize = () => {
    const drawer = document.querySelector('#cart-drawer');
    if (drawer) new MutationObserver(trackImpression).observe(drawer, { attributes: true, attributeFilter: ['hidden'] });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (pendingAdd && Date.now() - pendingAdd.started_at < 15000 && String(event.productVariantId || event.variantId || '') === pendingAdd.variant_id) {
          publish(`${EVENT_PREFIX}add`, pendingAdd);
          pendingAdd = null;
        }
        setTimeout(trackImpression, 450);
      });
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
